import Emoji from '@/components/emoji/index'

export default {
  components: {
    Emoji
  },

  data () {
    return {
      cursorRange: null,
      lastValidCursorRange: null,
      isComposing: false,
      isInputting: false,
      editorInitialized: false,
      // 用于跟踪最后一次手动交互的光标位置
      lastManualCursorRange: null
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.initCursorListener()
      this.editorInitialized = true
    })
  },

  beforeDestroy () {
    const editor = this.$refs.editableDiv
    if (editor) {
      editor.removeEventListener('mouseup', this.saveCursorPosition)
      editor.removeEventListener('keyup', this.saveCursorPosition)
      editor.removeEventListener('focus', this.saveCursorPosition)
      editor.removeEventListener('keydown', this.handleKeyDown)
      editor.removeEventListener('compositionstart', this.handlehandleCompositionStart)
      editor.removeEventListener('compositionend', this.handleCompositionEnd)
      // 移除新增的事件监听
      editor.removeEventListener('click', this.saveManualCursorPosition)
      editor.removeEventListener('touchend', this.saveManualCursorPosition)
    }
  },

  methods: {
    handleCompositionStart() {
      this.isComposing = true
    },

    initCursorListener () {
      const editor = this.$refs.editableDiv
      if (!editor) {
        console.warn('编辑器元素未找到，无法初始化光标监听')
        return
      }

      // 基础光标事件监听
      editor.addEventListener('mouseup', this.saveCursorPosition)
      editor.addEventListener('keyup', this.saveCursorPosition)
      editor.addEventListener('focus', this.saveCursorPosition)
      editor.addEventListener('keydown', (e) => this.handleKeyDown(e))
      editor.addEventListener('compositionstart', this.handleCompositionStart)
      editor.addEventListener('compositionend', this.handleCompositionEnd)
      editor.addEventListener('input', this.saveCursorPosition)
      
      // 新增：监听手动交互（点击/触摸）确保捕获最新光标位置
      editor.addEventListener('click', this.saveManualCursorPosition)
      editor.addEventListener('touchend', this.saveManualCursorPosition)
    },

    // 专门保存手动交互后的光标位置（优先级最高）
    saveManualCursorPosition() {
      if (this.isComposing || !this.editorInitialized) return
      
      const selection = window.getSelection()
      const editor = this.$refs.editableDiv
      
      if (selection.rangeCount && editor && editor.contains(selection.anchorNode)) {
        this.lastManualCursorRange = selection.getRangeAt(0).cloneRange()
        console.log('手动交互后光标位置:', {
          container: this.lastManualCursorRange.startContainer,
          offset: this.lastManualCursorRange.startOffset,
          content: this.lastManualCursorRange.startContainer.textContent
        })
      }
    },

    handleEmojiSelected (emoji) {
      const editor = this.$refs.editableDiv
      if (!editor || !this.editorInitialized) {
        console.error('编辑器未初始化，无法插入表情')
        return
      }

      try {
        // 1. 强制获取焦点并等待DOM更新
        editor.focus()
        
        // 2. 关键修复：插入前强制获取最新光标位置
        setTimeout(() => {
          // 3. 优先级判断：手动交互位置 > 当前选择 > 缓存位置
          let range = null
          const selection = window.getSelection()
          
          // 先检查是否有最新的手动交互光标位置
          if (this.lastManualCursorRange && 
              editor.contains(this.lastManualCursorRange.commonAncestorContainer)) {
            range = this.lastManualCursorRange.cloneRange()
            console.log('使用手动交互光标位置')
          }
          // 再检查当前选择对象
          else if (selection.rangeCount) {
            range = selection.getRangeAt(0).cloneRange()
            console.log('使用当前选择对象位置')
          }
          // 最后使用缓存的位置
          else {
            range = this.cursorRange || this.lastValidCursorRange
            console.log('使用缓存光标位置')
          }

          // 4. 验证范围有效性，无效则定位到内容末尾
          if (!range || !editor.contains(range.commonAncestorContainer)) {
            console.log('光标范围无效，定位到末尾')
            range = document.createRange()
            range.selectNodeContents(editor)
            range.collapse(false) // 折叠到末尾
          }
          // 5. 特殊处理：如果光标在空内容前，直接定位到末尾
          else if (editor.innerHTML.trim() === '' && range.startOffset === 0) {
            range.collapse(false)
          }

          // 创建表情元素
          const img = document.createElement('img')
          img.src = emoji.url
          img.alt = emoji.name || '表情'
          img.className = `emoji-img ${emoji.type || ''}`

          if (emoji.style) {
            Object.keys(emoji.style).forEach(key => {
              img.style[key] = emoji.style[key]
            })
          }

          // 清除选中内容
          if (!range.collapsed) {
            range.deleteContents()
          }

          // 插入表情
          const fragment = document.createDocumentFragment()
          fragment.appendChild(img)
          range.insertNode(fragment)

          // 移动光标到表情后面
          range.setStartAfter(img)
          range.collapse(true)

          // 更新选择范围
          selection.removeAllRanges()
          selection.addRange(range)

          // 同步更新所有光标缓存
          this.cursorRange = range.cloneRange()
          this.lastValidCursorRange = this.cursorRange.cloneRange()
          this.lastManualCursorRange = this.cursorRange.cloneRange()

          // 更新内容
          if (this.article && typeof this.article.content !== 'undefined') {
            this.article.content = editor.innerHTML
          }

          console.log('表情插入后光标位置:', {
            container: range.startContainer,
            offset: range.startOffset
          })
        }, 0)
      } catch (error) {
        console.error('表情插入失败:', error)
        if (this.$toast) {
          this.$toast.error('表情插入失败，请重试')
        }
      }
    },

    saveCursorPosition () {
      if (this.isComposing || !this.editorInitialized) return

      const selection = window.getSelection()
      const editor = this.$refs.editableDiv

      if (selection.rangeCount && editor && editor.contains(selection.anchorNode)) {
        this.cursorRange = selection.getRangeAt(0).cloneRange()
        this.lastValidCursorRange = this.cursorRange.cloneRange()
      }
    },

    // 新增：强制同步光标位置的方法
    forceSyncCursorPosition() {
      if (!this.editorInitialized) return
      
      const selection = window.getSelection()
      const editor = this.$refs.editableDiv
      
      if (selection.rangeCount && editor && editor.contains(selection.anchorNode)) {
        this.cursorRange = selection.getRangeAt(0).cloneRange()
        this.lastValidCursorRange = this.cursorRange.cloneRange()
        this.lastManualCursorRange = this.cursorRange.cloneRange()
        return this.cursorRange
      }
      return null
    },

    restoreCursorPosition () {
      if (this.isInputting || !this.editorInitialized) return

      const editor = this.$refs.editableDiv
      if (!editor) return

      try {
        const selection = window.getSelection()
        if (selection.isCollapsed) {
          selection.removeAllRanges()

          let rangeToRestore = this.forceSyncCursorPosition() || 
                              this.lastManualCursorRange || 
                              this.cursorRange || 
                              this.lastValidCursorRange

          if (rangeToRestore && editor.contains(rangeToRestore.commonAncestorContainer)) {
            const containerLength = rangeToRestore.startContainer.textContent
              ? rangeToRestore.startContainer.textContent.length
              : 0

            if (rangeToRestore.startOffset > containerLength) {
              this.moveCursorToEnd()
              return
            }

            selection.addRange(rangeToRestore)
          } else {
            this.moveCursorToEnd()
          }
        }
      } catch (e) {
        console.error('恢复光标失败:', e)
        this.moveCursorToEnd()
      }
    },

    moveCursorToEnd () {
      const editor = this.$refs.editableDiv
      if (!editor || !this.editorInitialized) return

      const selection = window.getSelection()
      const range = document.createRange()

      selection.removeAllRanges()

      // 处理长文本的特殊情况
      if (editor.innerHTML.trim() === '') {
        range.setStart(editor, 0)
        range.setEnd(editor, 0)
      } else {
        // 确保获取最后一个子节点
        let lastNode = editor.lastChild
        while (lastNode && lastNode.nodeType === 1 && lastNode.lastChild) {
          lastNode = lastNode.lastChild
        }
        range.selectNodeContents(editor)
        range.collapse(false)
      }

      selection.addRange(range)
      this.cursorRange = range.cloneRange()
      this.lastValidCursorRange = this.cursorRange.cloneRange()
      this.lastManualCursorRange = this.cursorRange.cloneRange()
    },

    // 其他方法保持不变...
    handleKeyDown (e) {
      this.isInputting = true
      if (e.key === 'Tab') {
        e.preventDefault()
      }
      this.saveCursorPosition()
    },

    handleCompositionEnd () {
      this.isComposing = false
      this.saveCursorPosition()
      setTimeout(() => {
        this.restoreCursorPosition()
      }, 0)
    },

    focusEditable () {
      const editor = this.$refs.editableDiv
      if (!editor || !this.editorInitialized) return

      editor.focus()
      // 聚焦时强制同步光标位置
      this.forceSyncCursorPosition()

      if (this.article && !this.article.content) {
        this.moveCursorToEnd()
        editor.removeAttribute('placeholder')
      } else if (!window.getSelection().rangeCount) {
        this.restoreCursorPosition()
      }
    }
  }
}
    